/* eslint-disable no-console */

import axios from 'axios'
import VueGeolocation from 'vue-browser-geolocation'


export default {
 
    /*
    * Local Bus List
    */

   localBusList: ({commit})  => {
    //console.log('localBusList action');
    VueGeolocation.getLocation()
    .then(coordinates => {
     // console.log(coordinates);
      return axios.get('https://marketplace.italyservices.it/martinimultimedia/gtfs/surroundigs/'+coordinates.lat+'/'+coordinates.lng+'/500');
    }).then( result => {
      commit('localbus_stops', result.data );
    });

    /*   try {
      let result = await 
      //console.log('===',result.data);
      commit('localbus_stops', result.data );
    }
    catch (error) {
        throw new Error(error)
    }
  /* 
  this.$getLocation();
    commit('localbus_stops', null);
*/
    /*
    this.$getLocation()
    .then(coordinates => {
      console.log(coordinates);
    });

    try {
        let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/gtfs/'+coordinates.lat+'/'+coordinates.lon+'/0.5');
        //console.log('===',result.data);
        commit('localbus_stops', result.data );
    }
    catch (error) {
        throw new Error(error)
    

    }
*/
   
},
    /*
    * Services
    */

    loadServices: async ({commit},lang) => {
      commit('services_set_loading', true );

        try {
            let result = await axios.get('https://marketplace.italyservices.it/'+lang+'/api/categories');
            //console.log('===',result.data);
            commit('services_set_list', result.data );
            commit('services_set_loading', false );
        }
        catch (error) {
            throw new Error(error)
        }
    },
    /*
    * DoorToDoor
    */

   doorToDoorList: async ({commit}) => {
    commit('doortodoor_set_loading', true );
      try {
        //if (!offset) {offset=1}
          
        
          let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/gtfs/trips/dates/153/10/1');
          //console.log('===',result.data);
          commit('doortodoor_set_list', result.data );
          commit('doortodoor_set_loading', false );
      }
      catch (error) {
          throw new Error(error)
          
      }
    },
    doorToDoorListAdd: async ({commit},skip) => {
      commit('doortodoor_set_loading_add', true );
        try {
          //if (!offset) {offset=1}
            
          
            let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/gtfs/trips/dates/153/10/'+skip);
            //console.log('===',result.data);
            commit('doortodoor_add_to_list', result.data );
            commit('doortodoor_set_loading_add', false );
        }
        catch (error) {
            throw new Error(error)
            
        }
      },
  
    setTrip: ({commit},payload) => {
      commit('doortodoor_set_trip',payload)
     },
    setStop: ({commit},payload) => {
      commit('doortodoor_set_stop',payload)
    },
    /*
    * Transfer
    */

   transferOnDate: ({commit},payload) => {
    commit('transfer_set_date',payload)
   },
   transferOnTime: ({commit},payload) => {
    commit('transfer_set_time',payload)
   },
   transferSetPeople: ({commit},payload) => {
    commit('transfer_set_people',payload)
   },
   transferSetAR: ({commit},payload) => {
    commit('transfer_set_ar',payload)
   },
    transferSearchFrom: async ({commit},payload) => {
      //  commit('transfer_set_from')
        try {
        let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/transfer/place/'+payload);
        //console.log('===',result.data);
        commit('transfer_from_items', result.data );
        
        }
        catch (error) {
            throw new Error(error)
        }
    },

    transferSetFirstName: ({commit},payload) => {
      commit('transfer_set_first_name',payload)
     },
    transferSetLastName: ({commit},payload) => {
      commit('transfer_set_last_name',payload)
     },
     transferSetPhone: ({commit},payload) => {
      commit('transfer_set_phone',payload)
     },
     transferSetNotes: ({commit},payload) => {
      commit('transfer_set_notes',payload)
     },

    transferSearchTo: async ({commit},payload) => {
        //commit('transfer_set_to')
        try {
        let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/transfer/place/'+payload);
        //console.log('===',result.data);
        commit('transfer_to_items', result.data );
        
        }
        catch (error) {
            throw new Error(error)
        }
        
    },
    transferBook: ({commit}) => {
      commit('transfer_book');
    }, 
    getPrice: async ({commit},payload) => {
        
        try {
      //      commit('transfer_find_loading');
            let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/transfer/price/' + payload.from + '/' + payload.to + '/' + payload.people);
            //console.log('===' + payload.from + '/' + payload.to + '/' + payload.people,result.data);
            commit('transfer_find', result.data );
        }
        catch (error) {
            throw new Error(error)
        }

    },
    getExtras: async ({commit},lang) => {
       
        try {
      //      commit('transfer_find_loading');
            let result = await axios.get('https://marketplace.italyservices.it/martinimultimedia/transfer/extra/' + lang);
            //console.log('===',result.data);
            commit('transfer_extras', result.data );
        }
        catch (error) {
            throw new Error(error)
        }

    },
    selectedExtras: ({commit},payload) => {
      commit('selected_extras',payload)
     },
    goToStep: async ({commit},n) => {

    commit('go_to_step', n );

    },



}